import type { UrlConfigServerType } from '@/services/url-config/urlConfig';
import { Any } from '@/shared/constant/any';
import { createContextStore } from '@/shared/util/createContextStore';

export type UrlConfigState = UrlConfigServerType;

export type UrlConfigAction = {};

const [UrlConfigModelStoreProvider, useUrlConfigModelStore] = createContextStore<
  UrlConfigState,
  UrlConfigAction
>(
  () => ({
    ...Any,
  }),
  false,
);

export { UrlConfigModelStoreProvider, useUrlConfigModelStore };
